// SiteAuthContext — wires `auth_form` blocks to a real sign-in flow.
//
// The smart-page runtime is auth-agnostic: in the designer canvas and the
// in-app preview an `auth_form` block renders as a visual-only form. When the
// Site preview hosts a branded login page (or any page containing an
// `auth_form`), it provides this context so RuntimeBlockHost can render the
// form with a working `onSubmit` (→ the project's end-user login) and an
// optional "Sign in with Twasta" handler. Absent provider = visual-only,
// exactly as before.

import { createContext, useContext } from 'react'
import type { AuthSubmit } from '@twasta/page-runtime/renderers'

export interface SiteAuthAdapter {
  onSubmit: AuthSubmit
  twastaSignin?: () => void
  /** Which tab an `auth_form` with `tabs` opens on (the host's `?mode=`). */
  initialMode?: 'login' | 'register'
}

export const SiteAuthContext = createContext<SiteAuthAdapter | null>(null)

export function useSiteAuth(): SiteAuthAdapter | null {
  return useContext(SiteAuthContext)
}
